__turbopack_context__.v({
  "icon": "list-module-scss-module__ffrANq__icon",
  "item": "list-module-scss-module__ffrANq__item",
  "item-with-icon": "list-module-scss-module__ffrANq__item-with-icon",
  "list": "list-module-scss-module__ffrANq__list",
  "with-custom-icons": "list-module-scss-module__ffrANq__with-custom-icons",
});
